import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GuideOverlay from './GuideOverlay';
import { Button } from '@mui/material';
import { guideSeen, saveGuideProgress } from './guideProgress';

export const profileSteps = [
  { target: '[data-tour="profile-sharing"]', title: 'Make your profile discoverable', body: '“Share my profile for case referral” controls your public visibility for discovery and referrals in MindVault. Clients can find your profile only when it is public. Complete the requirements, turn this switch on, then select Update to save.' },
  { target: '[data-tour="profile-requirements"]', title: 'What do I need to complete?', body: 'Items in red show what is still required to make your profile public: your registration verification and any missing profile details. Complete these before enabling sharing. If everything is complete, you are ready to turn sharing on.' },
  { target: '#payout-setup-section', title: 'Where you receive booking payments', body: 'Connect your payout bank account through Stripe. Eligible earnings from paid client bookings are transferred to this account on the platform’s monthly payout schedule. Complete the bank details and identity verification requested by Stripe.' },
  { target: '[data-tour="profile-save"]', title: 'Save your profile', body: 'Select Update after editing your profile or changing its public visibility. Payout setup is completed separately through Stripe. This tour has not changed or saved any of your details.' },
];

export default function ProfileGuide({ userId, ready }) {
  const location = useLocation();
  return <ProfileGuideSession key={`${userId}:${location.key}`} userId={userId} ready={ready} />;
}

function ProfileGuideSession({ userId, ready }) {
  const location = useLocation();
  const navigate = useNavigate();
  const key = `scribe-visual-onboarding-complete-detail:${userId}:profile`;
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [replaying, setReplaying] = useState(false);
  const preview = new URLSearchParams(location.search).get('guide') === 'profile';
  const otherTour = new URLSearchParams(location.search).has('tour');
  if (!ready || !userId || otherTour) return null;
  // Existing overview completion/skip flags also suppress automatic page guides.
  const overviewSeen = guideSeen(`scribe-visual-onboarding-complete:${userId}`);
  if (dismissed || (!replaying && !preview && (guideSeen(key) || overviewSeen))) return <Button type="button" onClick={() => { setIndex(0); setDismissed(false); setReplaying(true); }}>Replay profile walkthrough</Button>;
  const close = (completed = false) => {
    saveGuideProgress(key, completed);
    setDismissed(true);
    if (preview) {
      const params = new URLSearchParams(location.search);
      params.delete('guide');
      const search = params.toString();
      navigate(`${location.pathname}${search ? `?${search}` : ''}`, { replace: true, state: location.state });
    }
  };
  return <GuideOverlay step={profileSteps[index]} index={index} total={profileSteps.length} onBack={() => setIndex(index - 1)} onNext={() => index === profileSteps.length - 1 ? close(true) : setIndex(index + 1)} onClose={() => close()} />;
}
